/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

export const exportPostsPathSchema = z.object({ campaignId: z.string() });

export type ExportPostsInput = {
  path: z.input<typeof exportPostsPathSchema>;
  signal?: AbortSignal;
};

export async function exportPosts({
  path,
  signal,
}: ExportPostsInput): Promise<string> {
  const parsedPath = exportPostsPathSchema.parse(path);

  const response = await socialApiClient.post(
    `campaigns/${parsedPath.campaignId}/exports/posts`,
    {
      signal,
    },
  );
  return response.text();
}
